import Navbar from '../includes/navbar'
import Footer from '../includes/footer'
import {useTranslation} from "react-i18next";
import {usePageTitle} from "../helpers/page-title";

export default function NotFound() {
    const { t } = useTranslation();

    usePageTitle(`${t('title.not-found')} | ${t('title.gaocna')}`);

    return (
        <>
            <div className="not-found-container">
                <h1>404</h1>
                <p>{t(`not-found.message`)}</p>
                <a href="/" className="btn btn-primary">{t(`not-found.return`)}</a>
            </div>
        </>
    )
}